import { dataAttributeProps } from '@pbk-web/utils';
import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';

import InfoIcon from '../icons/InfoIcon';
import Tooltip from '../tooltip/Tooltip';

export type StatusTagProps = {
  text: string;
  className?: string;
  statusType: StatusVariant;
  bottomText?: string;
  infoText?: ReactNode;
  preserveSpace?: boolean;
  align?: 'center' | 'left';
};

export enum StatusVariant {
  GREEN,
  ORANGE,
  GRAY,
  RED,
  BLUE,
  GOLD,
}

const StatusTag: FC<StatusTagProps> = (props) => {
  const { text, className, statusType, bottomText, infoText, preserveSpace = true, align = 'center' } = props;

  const [textColorCss, backgroundColorCss] = useMemo(() => {
    switch (statusType) {
      default:
      case StatusVariant.RED: {
        return ['text-semantic-error', 'bg-semantic-error/10'];
      }
      case StatusVariant.GRAY: {
        return ['text-primary-100', 'bg-primary-100/10'];
      }
      case StatusVariant.ORANGE: {
        return ['text-accent-2-100', 'bg-accent-2-100/10'];
      }
      case StatusVariant.GREEN: {
        return ['text-semantic-success', 'bg-semantic-success-bg'];
      }
      case StatusVariant.GOLD: {
        return ['text-accent-4-100', 'bg-accent-4-100/10'];
      }
      case StatusVariant.BLUE: {
        return ['text-accent-3-100', 'bg-accent-3-100/10'];
      }
    }
  }, [statusType]);

  return (
    <div className={`flex flex-col ${align === 'left' ? 'items-start justify-start' : 'items-center justify-center'} gap-2`}>
      <div className={`flex flex-col items-center ${align === 'left' ? 'justify-start' : 'justify-center'} gap-2`}>
        <div className={`flex items-center ${align === 'left' ? 'self-start' : 'self-center'}`}>
          <div
            className={`${backgroundColorCss} inline-flex flex-row items-center rounded-[5px] px-3 py-1 ${className} ring-greyscale-5 ring-1 ring-inset`}
          >
            <div {...dataAttributeProps(props)} className={`text-pbk-14 w-full text-center font-medium ${textColorCss}`}>
              {text}
            </div>
          </div>
          <div className={infoText ? '' : preserveSpace ? 'invisible' : 'hidden'}>
            <Tooltip text={infoText}>
              {(tooltip) => (
                <span {...tooltip}>
                  <InfoIcon className={`h-5 w-5 ${textColorCss}`} />
                </span>
              )}
            </Tooltip>
          </div>
        </div>
        {align === 'left' && <div className={`text-pbk-12 -mb-2 text-left empty:hidden`}>{bottomText}</div>}
      </div>
      {align === 'center' && <div className={`text-pbk-12 -mb-2 text-center empty:hidden`}>{bottomText}</div>}
    </div>
  );
};

export default StatusTag;
